<template>
  <div class="yCenter">
    <div v-bind:style="{ width: getWidth('stockAdjustDate') }" class="colStyle">
      {{ items.stockAdjustDate }}
    </div>
    <div v-bind:style="{ width: getWidth('storage.name') }" class="colStyle">
      {{ getStorageName(items.adjustStorageId) }}
    </div>
    <div v-bind:style="{ width: getWidth('userId') }" class="colStyle">
      {{ getUserName(items.user) }}
    </div>

    <!-- ステータス -->
    <div class="yCenter font-weight-bold">
      <span v-if="isDisplay('status')" class="yCenter operationAreaStyle">
        <span class="primary--text statusNameStyle">
          {{ getStatusName(items.status) }}
        </span>
      </span>

      <NormalButton
        text="common.input_status-history"
        class="mr-2"
        btnClass="pa-2"
        height="32px"
        width="15px"
        color="white"
        textColor="thinText--text"
        :outlined="true"
        @click="statusHistory.dialog.dialog = true"
      />
      <StatusHistoryDialog
        v-model="statusHistory.dialog"
        pageType="StockAdjust"
        :tables="statusHistory.tables"
        itemKey=""
      />

      <NormalButton
        text="stock-adjust.stock-adjust_stock-adjust-details"
        height="32px"
        color="white"
        textColor="thinText--text"
        class="mx-2"
        btnClass="pa-2"
        :outlined="true"
        @click="detailDialog.dialog = true"
        :disabled="complete.dialog.status.isDisabled"
      />
      <StorageAdjustDetailDialog
        v-model="detailDialog"
        width="80%"
        :recItems="items"
        @submit="pageReload"
      />
    </div>
  </div>
</template>
<script>
import {
  countryUtil,
  countryCallingCodeUtil,
  stockAdjustUtil,
  storageUtil
} from '@/util'
import { shipStatusHistory } from '@/config'

import NormalButton from '@/components/items/Buttons/NormalButton'

import { StatusHistoryDialog } from '@/components/layouts/Dialogs'
import StorageAdjustDetailDialog from '@/components/layouts/Dialogs/MultipleArea/StorageAdjustInfoDialog/StorageAdjustDetailDialog'

import { mapActions } from 'vuex'

export default {
  components: {
    NormalButton,
    StatusHistoryDialog,
    StorageAdjustDetailDialog
  },
  props: {
    headers: { default: [] },
    items: { default: [] }
  },
  data: () => ({
    rowDialogMethodCommonName: 'rowDialogMethodCommon',

    detailDialog: {
      dialog: false
    },
    complete: {
      dialog: {
        dialog: false,
        data: {
          id: '',
          date: ''
        },
        status: {
          name: '',
          isDisabled: false
        }
      }
    },
    ship: {
      dialog: {
        dialog: false
      },
      tables: [
        {
          title: { default: '' },
          name: { default: '' },
          items: { default: [] },
          itemKey: { default: '' }
        }
      ]
    },
    statusHistory: {
      dialog: { dialog: false },
      tables: [
        {
          title: 'storage.storage_status-change-history',
          items: { default: [] },
          itemKey: ''
        }
      ]
    },
    payment: {
      dialog: {
        dialog: false
      },
      tables: [
        {
          title: { default: '' },
          name: { default: '' },
          items: { default: [] },
          itemKey: { default: '' }
        }
      ]
    }
  }),
  created() {
    this.ini()
  },
  methods: {
    ini() {
      this.complete.dialog.data.id = this.items.shipId
      this.statusHistory.tables[0].items = this.items.stockAdjustStatusHistories
    },
    getWidth(value) {
      const obj = this.headers.find((ele) => ele.value === value)
      return obj ? obj.width : '100px'
    },
    getUserName(user) {
      return user ? user.lastName + user.firstName : '-'
    },
    getStorageName(id) {
      return storageUtil.getStorageById(id)?.name
    },
    getStatusName(status) {
      return stockAdjustUtil.getStockAdjustStatusName(status)
    },

    isDisplay(value) {
      const obj = this.headers.find((ele) => ele.value === value)
      return obj ? true : false
    },
    pageReload() {
      this.$emit(this.rowDialogMethodCommonName, 'reload')
    }
  },

  computed: {}
}
</script>
<style lang="scss" scoped>
.colStyle {
  word-wrap: break-word;
}
.btnStyle {
  max-width: 105px;
  padding: 0px !important;
}
.statusNameStyle {
  width: 50px;
}
.operationAreaStyle {
  width: 80px;
}
</style>
